import axios from '../../axios';
import { useQuery } from '@tanstack/react-query';
import type { TPostWithAuthor, TError } from '@onesource/schemas';
import { ENTITY } from '../entity';

/**
 * API response shape for posts endpoint
 */
interface PostsResponse {
  posts: TPostWithAuthor[];
  total: number;
}

/**
 * Query key for fetching posts in a space - non-hook version
 */
export const getPostsQueryKey = (spaceId: string) => [ENTITY, 'posts', spaceId];

/**
 * Query key for fetching posts in a space
 */
export const useGetPostsQueryKey = (spaceId: string) => getPostsQueryKey(spaceId);

/**
 * Hook to fetch all posts in a feed sub-space
 * Returns posts ordered by creation date (newest first)
 *
 * @param spaceId - Space ID (UUID) - should be a feed sub-space
 */
export const useGetPosts = (spaceId: string) => {
  return useQuery<TPostWithAuthor[], TError>({
    queryKey: useGetPostsQueryKey(spaceId),
    queryFn: async () => {
      const res = await axios.get<PostsResponse>(`/community-hub/spaces/${spaceId}/posts`);
      return res.data.posts;
    },
    enabled: !!spaceId,
    staleTime: 60 * 1000, // 1 minute (posts change frequently)
  });
};
